<div [ngClass]="{'pe-cta':true,'pe-no-margin':item.data.fullWidth}"
     [ngStyle]="{maxWidth:layoutSetting.maxWidth + 'px'}">
  <app-sub-component-container [layoutSetting]="layoutSetting" [item]="item">

    <div class="pe-cta-header">
      {{ item.data.header}}
    </div>
    <div class="pe-cta-description">
      {{item.data.description}}
    </div>
    <div class="pe-cta-btns" [ngStyle]="{justifyContent:cs.alignToFlex( item.data.align)}">
      <div *ngFor="let l of item.data.Buttonlink;index as indexSlider">
        <a *ngIf="!viewOnly" mat-raised-button  [color]="l.colorLink">{{l.text}}</a>
        <a *ngIf="viewOnly" mat-raised-button target="_blank" [color]="l.colorLink" [href]="l.link">{{l.text}}</a>
      </div>
    </div>


  </app-sub-component-container>
</div>
